import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5045753c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-container" }
const _hoisted_2 = { class: "story-item" }
const _hoisted_3 = { class: "heading" }
const _hoisted_4 = { class: "story-action" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "bt-sm" }, "Edit", -1))
const _hoisted_6 = { class: "item-info" }

import router from "@/router";
import { TeamStory } from "@/services/entities/teamStory";


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryItem',
  props: {
    story: {}
  },
  setup(__props: any) {

const props = __props;

const formatDate = (date: Date | undefined | string): string => {
    if (!date) {
        return "";
    }
    else if (typeof date === 'string') {
        date = new Date(date);
    }
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return date.toLocaleDateString(undefined, options);
};

const goToDetail = () => {
    router.push({ name: 'Detail', params: { id: props.story.id } });
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.story.heading), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'Edit', params: { id: _ctx.story.id } }
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("button", {
            class: "bt-sm",
            onClick: goToDetail
          }, "Detail")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, "Created: " + _toDisplayString(formatDate(_ctx.story.created ?? _ctx.story.modifiedDateStamp)), 1),
        _createElementVNode("span", null, "Modified: " + _toDisplayString(formatDate(_ctx.story.modifiedDateStamp)), 1),
        _createElementVNode("span", null, "By " + _toDisplayString(_ctx.story.employee?.name), 1)
      ])
    ])
  ]))
}
}

})